
export default {
  layout: "green",
  head() {
    return {
      title: this.data.metaTitle,
      description: this.data.metaDescription,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.data.metaDescription,
        },
        {
          hid: "keywords",
          name: "keywords",
          content: this.data.keywords,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.data.metaTitle,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.data.metaDescription,
        },
        {
          hid: "og:url",
          property: "og:url",
          content: this.$nuxt.$route.path,
        },
        {
          hid: "og:type",
          property: "og:type",
          content: "website",
        },
        { hid: "robots", name: "robots", content: this.$config.robots_tag },
      ],
      script: [
        {
          json: {
            "@context": "https://schema.org",
            "@type": "Website",
            url: this.$nuxt.$route.path,
            name: this.data.schemaJson,
          },
          type: "application/ld+json",
        },
      ],
    };
  },
  async asyncData({ $strapi, params }) {
    try {
      const data = await $strapi.find(`solutions/${params.slug}`);

      return { data };
    } catch (err) {
      console.log("__category/_slug, solutions/");
      console.error(err);
      console.error({ statusCode: 404, message: err.response });
    }
  },
};
